import React, { createContext, useContext, useState } from "react";
import { useLoadScript, Libraries } from "@react-google-maps/api";

interface GoogleMapsContextProps {
  isLoaded: boolean;
  loadError: Error | undefined;
}

const GoogleMapsContext = createContext<GoogleMapsContextProps | undefined>(undefined);

export const GoogleMapsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // You can add more libraries as needed
  const [libraries] = useState<Libraries>(["places", "drawing", "core"]);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyDLCnmXMnyYiTp8_Vmp7BCz8-AAdG8bfNU",
    libraries,
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export function useGoogleMaps() {
  const ctx = useContext(GoogleMapsContext);
  if (!ctx) throw new Error("useGoogleMaps must be used within a GoogleMapsProvider");
  return ctx;
}
